module.exports = __webpack_public_path__ + "static/Sween-logo-color-21f96f289477fb33710f63fff2edb818.png";